import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createCostProfile(data: Boundaries["createCostProfile"]["request"]): void;
}

function useCreateCostProfile(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isCreateCostProfileRequestPending),
    isRequestSuccess: useSelector(selector.isCreateCostProfileRequestSuccess),
    isRequestFailure: useSelector(selector.isCreateCostProfileRequestFailure),
    createCostProfile: core.createCostProfile,
  };
}

export { useCreateCostProfile };
